import { Component } from 'react';

import { MessageIcon } from '../../../components/MessageCustom/icons';

class ErrorMessage extends Component {
    constructor() {
        super();
    }

    render() {
        const className = this.props.warning ? 'alert-warning' : 'alert-danger';
        return (
            <div className="ai-tracking-error-container">
                <div className={`custom-message alert ${className}`}>
                    <div className="custom-message-body">
                        <MessageIcon type={className} />
                        <div>{this.props.message}</div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ErrorMessage;
